import styled from 'styled-components'

import { Icon as DefaultIcon } from '@/components/ui/icon'
import { spin } from '@/theme/animations'

export const StyledButton = styled.button(({ theme }) => ({
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },

  alignItems: 'center',
  background: theme.colors.black800,
  border: 'none',
  borderRadius: theme.border.radius['16'],
  color: theme.colors.white,
  cursor: 'pointer',
  display: 'flex',
  fontSize: '1.6rem',
  fontWeight: 600,
  gap: theme.space['4'],
  height: '5.6rem',
  justifyContent: 'center',
  padding: `${theme.space['16']} ${theme.space['20']}`,
  textAlign: 'center',
  transition: `opacity ${theme.transition.duration.sm} ease`,
  width: '100%',
}))

export const SpinnerIcon = styled(DefaultIcon)`
  align-items: center;
  animation: ${spin} 1s linear infinite;
  display: flex;
  justify-content: center;
`
